// extracted by mini-css-extract-plugin
export var container = "_51-0";
export var disabled = "_51-4";
export var fullWidth = "_51-3";
export var lined = "_51-1";
export var selected = "_51-5";
export var tab = "_51-2";